'use client';

import {
  ApolloNextAppProvider,
  useQuery,
} from '@apollo/experimental-nextjs-app-support/ssr';
import { PropsWithChildren } from 'react';

import { SuspenseContext } from '@nerdwallet/apollo/suspense-context';

import { makeClient } from './client';

const ApolloWrapper: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ApolloNextAppProvider makeClient={makeClient}>
      <SuspenseContext.Provider value={{ maybeUseSuspenseQuery: useQuery }}>
        {children}
      </SuspenseContext.Provider>
    </ApolloNextAppProvider>
  );
};
export default ApolloWrapper;
